// extracted by mini-css-extract-plugin
export default {"productGrid":"v0-z","centerLink":"w0-z","productSection":"x0-z","item":"y0-z","ctaButton":"z0-z"};